(() => {
  const root = document.querySelector('[data-lilpillo-home]');
  if (!root) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const stage = root.querySelector('[data-cal-object]');


  requestAnimationFrame(() => root.classList.add('is-ready'));

  const reveals = root.querySelectorAll('.cal-reveal');
  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    reveals.forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -7% 0px' });
    reveals.forEach((element) => observer.observe(element));
  }

  const hero = root.querySelector('.cal-hero');
  if (!stage || !hero) return;

  let frame = 0;
  const render = () => {
    frame = 0;
    if (reducedMotion.matches) {
      stage.style.removeProperty('transform');
      stage.style.removeProperty('opacity');
      return;
    }

    // Keep the artwork within the compact hero, in both scroll directions.
    const bounds = hero.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -bounds.top / Math.max(1, bounds.height * 0.7)));
    const distance = Math.min(36, stage.offsetWidth * 0.055);
    const drop = Math.min(24, stage.offsetHeight * 0.08);
    stage.style.transform = `translate3d(${-distance * progress}px, ${drop * progress}px, 0) rotate(${2.4 * progress}deg) scale(${1 - 0.06 * progress})`;
    stage.style.opacity = '1';
  };

  const requestRender = () => {
    if (!frame) frame = requestAnimationFrame(render);
  };

  render();
  window.addEventListener('scroll', requestRender, { passive: true });
  window.addEventListener('resize', requestRender, { passive: true });
  reducedMotion.addEventListener('change', requestRender);
})();
